import React from "react";
import "./App.css";

import { RouterProvider } from "react-router";
import Router from "./routes/router";

const App = () => {
  return (
    <>
      <RouterProvider router={Router} />
    </>
  );
};

export default App;